
// animate.js

(() => {
  "use strict"; // Good practice for Babel/Uglify

  const initAnimations = () => {
    // 1. Performance Gate: Check Body Class
    if (!document.body.classList.contains('hasAnimation')) return;

    // 2. Observer Config
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1
    };

    // 3. The Observer
    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          obs.unobserve(entry.target);
        }
      });
    }, observerOptions);

    // 4. Target Selection
    // We scope this variables locally so it doesn't clash with other plugins
    const containers = document.querySelectorAll('[data-anim-container]');

    containers.forEach(container => {
      const children = container.querySelectorAll('.anim-el');
      children.forEach(el => observer.observe(el));
    });
  };

  // Initialize on DOM Ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAnimations);
  } else {
    initAnimations(); // DOM already ready (in case script loads late)
  }

})();